import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Logo from "../../images/logo.png";
import styles from "../../css/legal.module.css";

const PrivacyPage = () => {
  return (
    <Fragment>
      <Navbar hclass={"header-style-1"} Logo={Logo} btnClass={"theme-btn-s1"} />
      <PageTitle pageTitle={"Privacy Policy"} pagesub={"Privacy Policy"} />

      <section className={styles.section}>
        <div className={styles.container}>
          <p className={styles.updated}>Last updated: January 2026</p>

          <p className={styles.lead}>
            Roslindale Food Collective ("RFC," "we," "us," or "our") is a
            501(c)(3) nonprofit organization. This Privacy Policy explains how we
            handle information when you visit our website. We are committed to
            protecting your privacy and keep our data practices intentionally
            minimal.
          </p>

          <div className={styles.block}>
            <h2>Information We Collect</h2>
            <p>
              Our website does not collect, store, or sell personal information.
              We do not use accounts, logins, or tracking profiles. If you
              choose to contact us through our contact form or by email, we will
              only receive the information you voluntarily provide (such as your
              name, email address, and message) so that we can respond to you.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Donations</h2>
            <p>
              All donations are processed by trusted third-party platforms (such
              as Venmo and other payment providers). Roslindale Food Collective
              does not collect or store your payment or financial information on
              this website. Any information you share during a donation is
              handled by those platforms under their own privacy policies, and we
              encourage you to review them.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Cookies &amp; Analytics</h2>
            <p>
              We do not use advertising cookies or sell data to third parties.
              Any limited technical data (such as standard server logs) is used
              only to keep the website running securely and reliably.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Third-Party Links</h2>
            <p>
              Our website may link to external services (for example, social
              media pages or donation platforms). We are not responsible for the
              privacy practices of those sites and recommend reviewing their
              policies.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Children's Privacy</h2>
            <p>
              Our website is not directed to children under 13, and we do not
              knowingly collect personal information from children.
            </p>
          </div>

          <div className={styles.block}>
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please reach
              out at{" "}
              <a href="mailto:RosiFoodCollective@gmail.com">
                RosiFoodCollective@gmail.com
              </a>{" "}
              or by phone at 617-676-1717.
            </p>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default PrivacyPage;
